import { render, staticRenderFns } from "./vehicles.vue?vue&type=template&id=2c7bed50&scoped=true"
import script from "./vehicles.vue?vue&type=script&lang=js"
export * from "./vehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7bed50",
  null
  
)

export default component.exports